import { render, staticRenderFns } from "./CustomerInvoicesPayments.vue?vue&type=template&id=ebf0a752"
import script from "./CustomerInvoicesPayments.vue?vue&type=script&lang=js"
export * from "./CustomerInvoicesPayments.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoicesPayments.vue?vue&type=style&index=0&id=ebf0a752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports